module.exports = __webpack_public_path__ + "static/img/img_home_wg.366382c4.png";